import { render, staticRenderFns } from "./industryPage.vue?vue&type=template&id=04c1733a&scoped=true&"
import script from "./industryPage.vue?vue&type=script&lang=js&"
export * from "./industryPage.vue?vue&type=script&lang=js&"
import style0 from "./industryPage.vue?vue&type=style&index=0&id=04c1733a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1733a",
  null
  
)

export default component.exports